module.exports = __webpack_public_path__ + "39659a6bdbc429951ebecd1cfd359b59.MP3";